import { useMemo } from 'react';
import { hasPermission, getCurrentUserRole } from 'helpers/permissions';

/**
 * Custom hook to check user permissions
 * @param allowedRoles - Array of roles that are allowed
 * @returns Object with permission check results
 */
export const usePermission = (allowedRoles?: string[]) => {
  const userRole = useMemo(() => getCurrentUserRole(), []);
  const hasAccess = useMemo(
    () => (allowedRoles ? hasPermission(allowedRoles) : true),
    [allowedRoles]
  );

  return {
    hasAccess,
    userRole,
    hasPermission: (roles: string[]) => hasPermission(roles),
  };
};

